import { AppIcon } from '../AppIcon';
import { Tooltip } from '../Tooltip';

/** Downloads the PDF shown, from the start of the viewer's controls row, styled like the zoom buttons at its end. */
export function PdfDownloadButton({ url, fileName, title }: { url: string; fileName: string; title: string }) {
  return <div class="segmented">
    <Tooltip text="Download PDF"><a class="segmented-button" href={url} download={fileName} aria-label={`Download ${title} (PDF)`}><AppIcon name="download" /></a></Tooltip>
  </div>;
}
